__turbopack_context__.v({
  "divider": "readyToLearn-module-scss-module__bsz3oq__divider",
});
